<template>
  <div class="GoodsPage">
    <div class="pageTop">
      <h1>款式数据</h1>
      <!-- <h2 class="countrySel">地区选择</h2>
      <el-select class="country" v-model="region" placeholder="请选择">
        <el-option v-for="item in countryList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select> -->
      <el-date-picker
          v-model="dateValue"
          type="daterange"
          align="right"
          unlink-panels
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          @change="dateChange"
          :clearable="false"
      >
      </el-date-picker>

      <el-button @click="handleQuery">查询</el-button>
      <el-button @click="handleDownload" icon="el-icon-download">下载</el-button>
    </div>
    <div class="pageTable">
      <el-table
          :data="paginatedData"
          v-loadmore="loadMore"
          style="width: 100%;margin-bottom: 20px;"
          border
          height="600"
      >
        <el-table-column
            align="center"
            label="景区名称"
            prop="company_name"
        />
        <el-table-column
            align="center"
            label="仓库名称"
            prop="store_name"
        />
        <el-table-column
            align="center"
            label="商品名称"
            prop="goods_name"
        />
        <el-table-column
            align="center"
            label="商品类型"
            prop="goods_type_name"
        />
        <el-table-column
            align="center"
            label="销售数量"
            prop="sum_num"
            sortable
        />
        <el-table-column
            align="center"
            :label="`销售金额(${unit})`"
            prop="sum_amount"
            sortable
        />



      </el-table>
    </div>

  </div>
</template>

<script>


import EchartsNine from "./EchartsNine";
import SearchSelect from "@/views/components/SearchSelect";
import { getGoodsList, getGoodsDownload} from '@/api/bi'


export default {
  name: "StoreQuota",
  data(){


    return {
      region: '0', // 国家
      countryList: [
        { value: '0', label: '全部' },
        { value: '1', label: '中国大陆' },
        { value: '2', label: '中国香港' },
        { value: '3', label: '中国澳门' },
        { value: '4', label: '中国台湾' },
        { value: '5', label: '阿联酋' },
        { value: '6', label: '美国' },
        { value: '7', label: '韩国' },
      ],
      unit: '元', // 单位
      unitList: {
        0: '元',
        1: '元',
        2: '港元',
        3: '澳元',
        4: '台币',
        5: '迪拉姆',
        6: '美元',
        7: '韩元',
      },
      dateValue: [],

      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      tableData: [], // 表格数据
      currentPage: 1,
      pageSize: 100,
    }
  },
  created(){
    this.setRangeDates();
  },
  computed: {
    paginatedData() {
      const end = this.pageSize*this.currentPage;
      return this.tableData.slice(0, end);
    }
  },
  props: ['allStore'], // 全部景区列表
  beforeMount() {
    this.fetchData();
  },
  methods:{
    // 监听触底事件
    loadMore(){
       console.log('触底事件');
       this.currentPage = this.currentPage + 1;
    },
    setRangeDates() {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth(); // 月份从0开始，0为1月
      const day = today.getDate();

      let startDate, endDate;

      if (month === 0 && day === 1) {
        // 如果今天是1月1日，起始和结束日期为去年12月的1号和31号
        startDate = new Date(year - 1, 11, 1);
        endDate = new Date(year - 1, 11, 31);
      } else if (day === 1) {
        // 如果今天是一个月的1号，起始日期为上一个月的1号，结束日期为上一个月的最后一天
        startDate = new Date(year, month - 1, 1);
        endDate = new Date(year, month, 0); // 设置日期为0将自动设置为上个月的最后一天
        console.log(1111111,endDate)
      } else {
        // 如果今天是一个月中的其他日期，起始日期为这个月的1号，结束日期为昨天
        startDate = new Date(year, month, 1);
        endDate = new Date(year, month, day - 1);
      }

      this.dateValue = [this.formatDate(startDate), this.formatDate(endDate)]
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');

      return `${year}-${month}-${day}`;
    },

    handleQuery(){
      // 查询
      this.fetchData(); // 调用子组件的方法
    },

    dateChange(val){
      const [ start, end ] = val;
      console.log(start, end)
      console.log(this.dateValue)
    },
    fetchData(){
      this.unit = this.unitList[this.region]
      const params = {
        start: this.dateValue && this.dateValue[0], // 开始日期
        end: this.dateValue && this.dateValue[1], // 结束日期
        // source: this.category || undefined, // 来源 1 纪念币， 2 大牌
        region_id: this.region * 1, // 区域id
      }
      getGoodsList(params).then(res => {
        this.tableData = [];
        if(res && res.code === 2000 && res.data) {
          if(res.data.constructor.name === 'Array') {
            this.tableData = res.data;
            this.currentPage = 1
          }
        }
      })

      console.log('请求数据')

    },

    handleDownload(){
      const params = {
        start: this.dateValue && this.dateValue[0], // 开始日期
        end: this.dateValue && this.dateValue[1], // 结束日期
        source: this.category || undefined, // 来源 1 纪念币， 2 大牌
        company_id_list: this.store || undefined, // 景区id
        region_id: this.region * 1, // 区域id
      }
      this.$confirm(`确认下载数据吗？`).then(() => {
        // 下载
        getGoodsDownload(params).then((data) => {
          this.download(data);
        })
            .catch((error) => {
              this.$message.error(error);
            });
      })
    },
    download(resp) {
      const fileName = '款式分析';
      const blob = new Blob([resp.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const href = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = href;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(a.href);
      }
    },
  },


  components: {
    SearchSelect,
    EchartsNine
  }
}
</script>

<style scoped>
.country{
  margin-right: 20px;
}

/** {*/
/*  scrollbar-width: thin;*/
/*  scrollbar-color: #58D9F9 #F5F5F5;*/
/*}*/
/* 改变滚动条的宽度和颜色 */
::-webkit-scrollbar {
  background-color: transparent;
  width: 10px;
  border: 1px solid;
  border-radius: 5px;
}
::-webkit-scrollbar-thumb {
  background-color: #58D9F9;
  border-radius: 5px;
}

/* 改变滚动条被悬停时的颜色 */
::-webkit-scrollbar-thumb:hover {
  background-color: #7CFFB2;
}

/* 改变滚动条的轨道宽度和颜色 */
::-webkit-scrollbar-track {
  background-color: transparent;
  border-radius: 5px;
}


.pageTop {
  display: flex;
  margin-bottom: 10px;
  align-items: center;
}

.pageTop h1{
  margin-right: 30px;
  font-size: 22px;
  font-weight: bold;
}

.pageTop h2{
  margin: 0 10px;
}

.pageTop .mineSelect {
  margin: 0 10px;
}

.GoodsPage,
.deviceBox{
  font-size: 16px;
  color: #ffffff;
  padding: 20px;
  border: 1px solid #5c01b8;
  border-radius: 30px;
  width: 95%;
  margin: 10px auto;

}

.GoodsPage {
  box-shadow: 0 0 10px;
  /*border-color: #58D9F9;*/
  margin-top: 30px;
}

.pageTable {
  margin-top: 40px;
}
.el-button {
  margin-left: 10px;
}

.el-button:hover {
  color: #ffffff;
  background-color: #5c01b8;
  border-color: #5c01b8;

}
</style>

<style>
/** {*/
/*  scrollbar-width: thin;*/
/*  scrollbar-color: #58D9F9 #F5F5F5;*/
/*}*/
/* 改变滚动条的宽度和颜色 */
.GoodsPage ::-webkit-scrollbar {
  background-color: transparent;
  width: 10px;
  border: 1px solid;
  border-radius: 5px;
}
.GoodsPage ::-webkit-scrollbar-thumb {
  background-color: #58D9F9;
  border-radius: 5px;
}

/* 改变滚动条被悬停时的颜色 */
.GoodsPage ::-webkit-scrollbar-thumb:hover {
  background-color: #7CFFB2;
}

/* 改变滚动条的轨道宽度和颜色 */
.GoodsPage ::-webkit-scrollbar-track {
  background-color: transparent;
  border-radius: 5px;
}

.GoodsPage .el-table {
  background: transparent !important;
  color: #fff;
  font-size: 16px;
}

.GoodsPage .el-table tr {
  background: transparent;
}

.GoodsPage .el-table th.el-table__cell {
  background: transparent !important;
  color: #fff;
}

.GoodsPage .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
  color: #58D9F9;
  font-weight: bold;
  background: transparent !important;
}

.GoodsPage .el-table th.el-table__cell.is-leaf {
  /*border-bottom: none;*/
}


</style>